import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';

import axios from 'axios';
import { mainurl, imgurl } from '../../Mainurl';
import { confirm } from '../../component/utility/confirm';
import { notification } from '../../component/hocs/notification';

import { Row, Col, Card, CardBody, FormGroup, Input, Label, Form, Spinner, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FaEye, FaEdit, FaPlusCircle, FaClipboardList } from 'react-icons/fa';
import { MdDeleteForever } from 'react-icons/md';

const CropMasterList = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState('');

    const [addModal, setAddModal] = useState(false);
    const [code, setCode] = useState('');
    const [name, setName] = useState('');

    const [stateOpt, setStateOpt] = useState('');
    const [state, setState] = useState("0");
    const [season, setSeason] = useState("0");
    const [seasonOpt, setSeasonOpt] = useState([
        <option value={1}> Kharif </option>,
        <option value={2}> Rabi </option>,
        <option value={3}> Garma </option>
    ]);

    useEffect(() => {
        //crop_list();
        get_state_list();
    }, [])

    const get_state_list = () => {

        let postData = [{ "country_code": "1", "user_id": sessionStorage.getItem('user_id') }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.state_code}> {row.state_name}</option>
                    )
                });

                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const crop_list = () => {
        setLoading(true);
        setTableData('');
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "state_id": state, "season_id": season, "crop_code": 10003 }];
        axios({
            method: 'post',
            url: mainurl + 'Trace/nutri_crop_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data != null) {

                    let list = response.data.map((row, index) => {

                        return (
                            {
                                sl: index + 1,
                                name: row.harvest_crop_name,
                                name_h: row.harvest_crop_name_ne,
                                crop_img: <img className='p-1' src={imgurl + row.photo} height="50px" alt="crop" />,
                                status: <MdDeleteForever className='cursor' size={20} color="#ff1616" onClick={() => delete_handler(row)} />

                            }
                        )
                    });
                    setLoading(false);
                    setTableData(list);
                } else {
                    setTableData([]);
                    setLoading(false);
                    let notify = notification({ message: "Crop list not Found.", type: 'error' });
                    notify();
                }
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }
    const back_handler = () => {
        setMode(1);
        crop_list();
    }

    const delete_handler = async (row) => {
        if (await confirm(`Are you sure you want to delete this crop?`)) {
            let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "state_id": "12", "season_id": "1", "crop_code": row.crop_code }]

            axios.post(mainurl + 'Trace/nutri_crop_delete', postData)
                .then(function (response) {

                    crop_list();
                    setLoading(false);
                    let notify = notification({ message: 'crop deleted successfully', type: 'success' });
                    notify();
                })
                .catch(function (error) {
                    setLoading(false);
                });
        }
    }

    const add_handler = () => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "state_id": state, "season_id": season, "crop_name": name, "crop_code": 10003 }]

        console.log(postData);
        axios.post(mainurl + 'Trace/nutri_crop_add', postData)
            .then(function (response) {

                crop_list();
                setLoading(false);
                let notify = notification({ message: 'crop added successfully', type: 'success' });
                notify();
            })
            .catch(function (error) {
                setLoading(false);
            });
    }

    return (
        <>
            <Header />
            <Page title='Crop Master' breadcrumbs='Home / Crop Master'>
                {mode === 1 &&
                    <Row className='p-3'>
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Row>
                                        <Col sm={3} className="mb-2">
                                            <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => setState(e.target.value)}>
                                                <option value="0"> --Select State-- </option>
                                                {stateOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={3} className="mb-2">
                                            <Input id="season" bsSize="sm" type="select" value={season} onChange={(e) => setSeason(e.target.value)}>
                                                <option value="0"> --Select Season-- </option>
                                                {seasonOpt}
                                            </Input>
                                        </Col>
                                        <Col md={2}>
                                            <Button className='text-white' color='primary' size="sm" block onClick={crop_list}> <FaClipboardList className='me-1' size={20} /> Get List</Button>
                                        </Col>
                                        <Col md={2}>
                                            <Button className='text-white' color='primary' size="sm" block onClick={() => setAddModal(true)}>
                                                <FaPlusCircle className='me-1' size={20} />
                                                Add New Crop
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={{ offset: 2, order: 2, size: 8 }}>
                            <Card className='' color="primary" outline>
                                <CardBody>
                                    <DataTable
                                        title=""
                                        customStyles={custTableStyles}
                                        columns={[
                                            {
                                                name: '#',
                                                selector: row => row.sl,
                                                sortable: true,
                                                width: '80px'
                                            },
                                            {
                                                name: 'Name',
                                                selector: row => row.name,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Name Hindi',
                                                selector: row => row.name_h,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Image',
                                                selector: row => row.crop_img,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Status',
                                                selector: row => row.status,
                                                sortable: false,
                                            },
                                        ]}
                                        data={tableData}
                                        highlightOnHover
                                        pagination
                                        progressPending={loading}
                                    />
                                </CardBody>
                            </Card>
                        </Col>

                    </Row>
                }
            </Page>
            <Footer />
            {/* Add Modal Start*/}
            <Modal
                centered
                scrollable
                size="lg"
                isOpen={addModal}
                toggle={() => setAddModal(!addModal)}
            >
                <ModalHeader toggle={() => setAddModal(!addModal)}>
                    Add New Crop
                </ModalHeader>
                <ModalBody className=''>
                    <Form onSubmit={(e) => { e.preventDefault(); add_handler(); }}>
                        <Row>
                            <Col sm={6} className="mb-2">
                                <Label>State <span style={{ color: 'red' }}>*</span></Label>
                                <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => setState(e.target.value)}>
                                    <option value="0"> --Select State-- </option>
                                    {stateOpt}
                                </Input>
                            </Col>
                            <Col sm={6} className="mb-2">
                                <Label>Season <span style={{ color: 'red' }}>*</span></Label>
                                <Input id="season" bsSize="sm" type="select" value={season} onChange={(e) => setSeason(e.target.value)}>
                                    <option value="0"> --Select Season-- </option>
                                    {seasonOpt}
                                </Input>
                            </Col>
                            {/* <Col md="6" className='mb-2'>
                                <Label>Crop Code <span style={{ color: 'red' }}>*</span></Label>
                                <Input bsSize="sm" type="text"
                                    placeholder="Enter Crop code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    required />
                            </Col> */}
                            <Col md="6" className='mb-2'>
                                <Label>Crop Name <span style={{ color: 'red' }}>*</span></Label>
                                <Input bsSize="sm" type="text"
                                    placeholder="Enter Crop Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required />
                            </Col>

                            <Col xs={12} className='text-end'>
                                <Button className='text-white mt-4' color='primary' size="sm" > <FaPlusCircle size={20} disabled={loading} /> Add {loading && <Spinner color="secondary ms-1" size="sm" >Load...</Spinner>}</Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
            {/* Add Modal End*/}
        </>
    )
}

export default CropMasterList;